<p-dialog header="Refund Payment" [(visible)]="displayModalRefund" [style]="{width: '50vw'}" [baseZIndex]="10000" [modal]="true">
    <div class="surface-card p-4 shadow-2 border-round" style="margin-top:5px;">
        <div class="field mb-4 col-12">
            <label for="refundvalue" class="font-medium">Refund Value</label>&nbsp;
            <br>
            <p-inputNumber inputId="refundvalue" [(ngModel)]="RefundPayment" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="RefundMax"></p-inputNumber>
            <small class="block mt-1" style="color:#6c757d;">Up to {{RefundMax | currency:CurrencySymbol}} can be refunded on this payment. Leave it as it is for the whole amount, or type less for part of it.</small>
        </div>
        <div *ngIf="!RefundPaymentValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Refund value of up to {{RefundMax | currency:CurrencySymbol}}.</div>

        <div class="field mb-4 col-12">
            <label for="refundreason" class="font-medium">Refund Reason</label>&nbsp;
            <br>
            <textarea id="refundreason" pInputText type="text" [(ngModel)]="RefundReason" style="width:100%; height: 100px;"></textarea>
        </div>
        <div *ngIf="!RefundTextValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Reason.</div>

        <p><b>Items will be refunded to the same payment type as the payment was originally made in.</b></p>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" label="Refund" styleClass="p-button p-button-success" (click)="doRefund()"></p-button>
        &nbsp;
        <p-button icon="pi pi-times" label="Cancel" styleClass="p-button p-button-danger" (click)="closeRefund()"></p-button>
    </ng-template>
</p-dialog>

<div *ngIf="pageReady" class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Edit a Gift Voucher
    </h3></div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Edit a gift voucher.
    </p>

    <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px">
        <p-tabView>

            <p-tabPanel header="Voucher Details">
                <ng-template pTemplate="header">
                    <i class="pi pi-ticket" style="margin-right: 5px;"></i>
                    <span>Voucher Details</span>
                </ng-template>

                <div class="grid formgrid p-fluid">
                    <div class="field mb-4 col-12">
                        <label class="font-medium">Voucher Code/PIN</label>
                        <div class="vch-value">
                            <strong>{{Voucher.vouchercode}}</strong>&nbsp;/&nbsp;<strong>{{Voucher.voucherpin}}</strong>
                        </div>
                    </div>

                    <div class="field mb-4 col-12">
                        <label class="font-medium">Purchased</label>
                        <div class="vch-value">{{Voucher.created | date:'dd/MM/yyyy'}}</div>
                    </div>

                    <div class="field mb-4 col-12">
                        <label class="font-medium">Expiry Date</label>
                        <div>
                            <p-calendar [selectOtherMonths]="true" [style]="{'margin-top' : '10px'}" [showIcon]="true" [showButtonBar]="true" [showOnFocus]="true" [showTime]="false" [readonlyInput]="true" [minDate]="minDate" [maxDate]="maxDate" [dateFormat]="'dd/mm/yy'" [locale]="en" [(ngModel)]="Voucher.expiry"></p-calendar>
                        </div>
                    </div>

                    <div class="field mb-4 col-12">
                        <label class="font-medium">Value</label>
                        <div class="vch-value">{{Voucher.balance | currency: CurrencySymbol}}</div>
                    </div>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Customer Details">
                <ng-template pTemplate="header">
                    <i class="pi pi-user" style="margin-right: 5px;"></i>
                    <span>Customer Details</span>
                </ng-template>

                <div class="grid formgrid p-fluid">
                    <div class="field mb-4 col-12">
                        <label for="customername" class="font-medium">Your Name</label>
                        <input id="customername" type="text" pInputText autocomplete="family-name" [(ngModel)]="Voucher.customername">
                    </div>
                    <div *ngIf="!NameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a last name.</div>

                    <div class="field mb-4 col-12">
                        <label for="email" class="font-medium">Email</label>
                        <input id="email" type="email" pInputText autocomplete="email" [(ngModel)]="Voucher.emailaddress">
                    </div>

                    <div *ngIf="!EmailValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an email address.</div>
                    <div *ngIf="!EmailFormatValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid email address.</div>

                    <div class="field mb-4 col-12">
                        <label for="voucherForSomeoneElse" class="font-medium">Is this voucher is for someone else?</label>
                        <p-selectButton id="voucherForSomeoneElse" [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Voucher.alternativerecipient"></p-selectButton>
                    </div>

                    <!-- Only asked for when the voucher is going to someone other than the buyer. -->
                    <div *ngIf="Voucher.alternativerecipient" class="col-12 vch-recipient">
                        <label class="font-medium">Recipient Information</label>

                        <div class="field mb-4 col-12">
                            <label for="lastname" class="font-medium">Recipient's Name</label>
                            <input id="lastname" type="text" pInputText autocomplete="family-name" [(ngModel)]="Voucher.recipientsname">
                        </div>
                        <div *ngIf="!RecipientNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a last name.</div>

                        <div class="field mb-4 col-12">
                            <label for="recipientemail" class="font-medium">Recipient's Email</label>
                            <input id="recipientemail" type="email" pInputText autocomplete="email" [(ngModel)]="Voucher.recipientsemailsaddress">
                        </div>

                        <div *ngIf="!RecipientEmailValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an email address.</div>
                        <div *ngIf="!RecipientEmailFormatValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid email address.</div>

                        <div class="field mb-4 col-12">
                            <label for="vouchermessage">Message</label>
                            <textarea id="vouchermessage" pInputText type="text" style="width:100%; height: 100px;" [(ngModel)]="Voucher.message"></textarea>
                        </div>
                        <div *ngIf="!messageValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a message.</div>
                    </div>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Payment Details">
                <ng-template pTemplate="header">
                    <i class="pi pi-credit-card" style="margin-right: 5px;"></i>
                    <span>Payment Details</span>
                </ng-template>

                <div class="vch-paid">
                    <span>Paid to date</span>
                    <span class="vch-paid-value">{{totalPaid | currency:CurrencySymbol}}</span>
                </div>

                <div *ngIf="Voucher.payments != null && Voucher.payments.length > 0">
                    <p-table [value]="Voucher.payments" responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width:4%">&nbsp;</th>
                                <th style="width:20%">Date</th>
                                <th style="width:18%">User</th>
                                <th style="width:14%">Method</th>
                                <th style="width:18%">Reason</th>
                                <th style="width:10%">Amount</th>
                                <th style="width:10%">Balance</th>
                                <th style="width:10%">&nbsp;</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-payment>
                            <!-- Money taken. -->
                            <tr *ngIf="payment.amount > 0">
                                <td><img alt="Payment" src="assets/images/paymentin.png" style="width: 25px; height: 25px;"/></td>
                                <td>{{payment.paymentDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                <td>{{payment.username}}</td>
                                <td>{{payment.method}}</td>
                                <td>{{payment.refundreason}}</td>
                                <td>{{payment.amount | currency:CurrencySymbol}}</td>
                                <td>{{payment.balance | currency:CurrencySymbol}}</td>
                                <td>
                                    <button *ngIf="payment.balance > 0" pButton type="button" style="height: 36px; width: 100px; margin-top:0px" class="p-button p-button-danger" (click)="setupRefund(payment)">
                                        <span>Refund</span>
                                    </button>
                                    <button *ngIf="!(payment.balance > 0)" pButton type="button" style="height: 36px; width: 100px; margin-top:0px; border-color: #cccccc; background-color: #cccccc !important;" [disabled]="true" class="p-button p-button">
                                        <span>Refund</span>
                                    </button>
                                </td>
                            </tr>

                            <!-- Money given back. Refunds come back as negative rows. -->
                            <tr *ngIf="payment.amount <= 0">
                                <td><img alt="Refund" src="assets/images/paymentout.png" style="width: 25px; height: 25px;"/></td>
                                <td class="vch-out">{{payment.paymentDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                <td class="vch-out">{{payment.username}}</td>
                                <td class="vch-out">{{payment.method}}</td>
                                <td class="vch-out">{{payment.refundreason}}</td>
                                <td class="vch-out">{{payment.amount | currency:CurrencySymbol}}</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <div *ngIf="Voucher.payments == null || Voucher.payments.length == 0">
                    No payments have been made against this voucher.
                </div>
            </p-tabPanel>

        </p-tabView>
    </div>

    <!-- Outside the tabs: saving saves the whole voucher, not just the tab being looked at. -->
    <div class="col-12">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
        <span class="pi pi-pencil" style="margin-right:8px;"></span>
        Save Changes</button>
        &nbsp;
        <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
        <span class="pi pi-times" style="margin-right:8px;"></span>
        Cancel</button>
    </div>
</div>
